import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Text, Title } from '@repletoryreach/sdk-ui';
import './billing.css';

const TONE_VAR = 'var(--rr-color-primary)';

/**
 * A section of billing, as a card that navigates as a whole.
 *
 * The whole card is the link rather than five characters of "Open →", because
 * a card-sized target is what the design draws and what a person aims at.
 */
export function BillingNavCard({ title, hint, to, icon }: {
  title: ReactNode;
  hint: ReactNode;
  to: string;
  icon: ReactNode;
}) {
  return (
    <Link to={to} className="rr-billing-navcard">
      <span
        className="rr-billing-navcard__icon"
        style={{ color: TONE_VAR, background: `color-mix(in srgb, ${TONE_VAR} 12%, transparent)` }}
        aria-hidden
      >
        {icon}
      </span>
      <span className="rr-billing-navcard__body">
        <Title order={5}>{title}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)">{hint}</Text>
      </span>
      <span className="rr-billing-navcard__chev" aria-hidden>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="m6 3.5 5 4.5-5 4.5" />
        </svg>
      </span>
    </Link>
  );
}
